import { groq } from 'next-sanity';

export const pageQuery = groq`
*[slug.current == $slug][0] {
  ...,
  'author': author->{
    name,
    'slug': slug.current,
  },
  tags,
  'categories': categories[]->{
    ...,
    'slug': slug.current,
  },
  'socials': {
    defined(instagram) => {instagram},
    defined(facebook) => {facebook},
  },
  'image': image{
    ...,
    hotspot,
    'metadata': asset->{
      ...metadata{
        lqip,
        blurHash
      }
    },
  },
  'slug': slug.current,
  'body': body[]{
    ...,
    _type == 'header' => {
      ...,
      image != null => {
          ...,
          hotspot,
          'metadata': asset->{
            ...metadata{
              lqip,
              blurHash
            }
          }
        }
    },
    _type == 'stackedHeader' => {
    ...,
    images[] {
      ...,
      image {
        ...,
        hotspot,
        'metadata': asset->{
          ...metadata {
            lqip,
            blurHash
          }
        }
      }
    }
    },
    _type == 'twoColumn' => {
      ...,
      'media': media[] {
          ...,
          _type == 'image' => {
            hotspot,
            'metadata': asset->{
              ...metadata{
                lqip,
                blurHash
            }
          }
        }
      }
    },
    // Get min price for all services
    _type == 'pricing' => {
      ...,
      'services': *[_type == 'stylist'].prices[] {...} | order(orderRank)
    },
    // Fetch index documents for pageIndex components
    _type == 'pageIndex' => {
      ...,
      'indexEntries': *[_type == ^.contentType]{
        ^.contentType == 'stylist' => {
          'title': name,
          'subHeading': bio
          // 'description': bio,
        },
        ^.contentType != 'stylist' => {
          ...,
        },
        'slug': slug.current,
        'image': image {
          ...,
          hotspot,
          'metadata': asset->{
            ...metadata{
              lqip,
              blurHash
            }
          },
        }
      } | order(_createdAt desc, lower(title) asc)
    },
    _type == 'stylistList' => {
      ...,
      'stylists': *[_type == 'stylist'] {
        ...,
        'slug': slug.current,
        'image': image {
          ...,
          hotspot,
          'metadata': asset->{
            ...metadata{
              lqip,
              blurHash
            }
          },
        }
      } | order(orderRank)
    }
  }
}
`;

export const allPagesQuery = groq`
*[slug.current != '/' && slug.current != null] {
  'slug': slug.current
}
`;
